import { ColDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { formatCurrency } from '@angular/common';
import { FinanceAmountCellComponent } from './finance-amount-cell/finance-amount-cell.component';

export const setFinanceAmountCol: (year: string) => ColDef = (year) => {
  return {
    colId: year,
    field: year,
    headerName: year,
    minWidth: 280,
    maxWidth: 280,
    valueGetter: (params: ValueGetterParams) => {
      return params.data[year]
    },
    valueFormatter: (params: ValueFormatterParams) => {
      return formatCurrency(params.data[year], 'en-US', '$')
    },
    editable: true,
    cellEditor: 'agTextCellEditor',
    cellRenderer: FinanceAmountCellComponent
  };
};
